import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import TableCell from '@material-ui/core/TableCell';
import { styles as tableCellStyles } from '@material-ui/core/TableCell/TableCell';
import { styles as tableRowStyles } from '@material-ui/core/TableRow/TableRow';
import { Link } from 'react-router-dom';

// Styles
import withStyles from '@material-ui/core/styles/withStyles';

const styles = theme => {
  let cellStyles = tableCellStyles(theme);
  let rowStyles = tableRowStyles(theme);

  return {
    root: {
      textDecoration: 'none',
      padding: 0,
      height: rowStyles.root.height,
    },
    link: {
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      color: '#000',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      height: 'inherit',
      textDecoration: 'none',
    },
    ellipsis: {
      padding: cellStyles.root.padding,
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    },
  };
};

class TableCellLink extends PureComponent {
  static propTypes = {
    to: PropTypes.string,
    classes: PropTypes.object.isRequired,
    className: PropTypes.string,
    children: PropTypes.node,
    staticContext: PropTypes.any,
  };

  render() {
    const { to, classes, className, children, staticContext, ...otherProps } = this.props;

    const elem = to ? (
      <Link to={to} className={classes.link}>
        <div className={classes.ellipsis}>{children}</div>
      </Link>
    ) : (
      <div className={classes.ellipsis}>{children}</div>
    );

    const classname = classnames(classes.root, className);

    return (
      <TableCell className={classname} {...otherProps}>
        {elem}
      </TableCell>
    );
  }
}

export default withStyles(styles)(TableCellLink);
